import axios from 'axios'
import Raven from 'raven-js'
import store from '@/store'

const readVehicles = async () => {
  try {
    const result = await axios.get('/4.1/vehicles/user_vehicles/')
    store.commit('Vehicles/setVehicles', result.data)
  } catch (err) {
    Raven.captureException(err)
    store.dispatch('SnackBar/setSnack', { snack: 'Une erreur s\'est produite lors de la récupération des véhicules', type: 'error' }, { root: true })
    store.dispatch('Alert/setAlert', { alert: 'Une erreur s\'est produite lors de la récupération des véhicules', type: 'error' })
  }
}

const updateVehicle = async (userId, data) => {
  try {
    const vehicle = await axios.put('/4.1/vehicles/user_vehicles/' + userId + '/', data)
    store.dispatch('Vehicles/editVehicle', vehicle.data)
    store.dispatch('SnackBar/setSnack', { snack: `Le véhicule ${vehicle.data.fields.vehicle_registration} a été mis à jour`, type: 'success' })
  } catch (err) {
    createUpdateVehicleErrorHandler(err)
  }
}

const createVehicle = async data => {
  try {
    const vehicle = await axios.post('/4.1/vehicles/user_vehicles/', data)
    store.dispatch('Vehicles/addVehicle', vehicle.data)
    store.dispatch('Alert/setAlert', { alert: `Le véhicule ${vehicle.data.fields.vehicle_registration} a bien été enregistré`, type: 'success' })
    store.dispatch('SnackBar/setSnack', { snack: `Le véhicule ${vehicle.data.fields.vehicle_registration} a bien été enregistré` })
  } catch (err) {
    createUpdateVehicleErrorHandler(err)
  }
}

const createUpdateVehicleErrorHandler = err => {
  console.log(err)
  if (err.response && err.response.status === 401) {
    return
  }
  if (err.response && err.response.status === 403 && err.response.data === 'Vehicle already added with the same license plate') {
    store.dispatch('Alert/setAlert', { alert: 'Ce véhicule est déjà enregistré', type: 'error' })
    store.dispatch('Snack/setSnack', { snack: 'Ce véhicule est déjà enregistré', type: 'error' })
  } else {
    Raven.captureException(err)
    store.dispatch('Alert/setAlert', { alert: 'L\'enregistrement du vehicule n\'a pas pu être effectué', type: 'error' })
    store.dispatch('SnackBar/setSnack', { snack: 'L\'enregistrement du vehicule n\'a pas pu être effectué', type: 'error' })
  }
}

const deleteVehicle = async id => {
  try {
    await axios.delete('/4.1/vehicles/user_vehicles/' + id + '/')
    store.dispatch('Vehicles/deleteVehicle', id)
    store.dispatch('SnackBar/setSnack', { snack: 'Le véhicule a bien été supprimé', type: 'success' })
  } catch (err) {
    Raven.captureException(err)
    store.dispatch('SnackBar/setSnack', { snack: 'La suppression du vehicule a échoué', type: 'error' })
  }
}

export {
  readVehicles,
  createVehicle,
  updateVehicle,
  deleteVehicle
}